// extracted by mini-css-extract-plugin
export default {"loader__spinner":"_1kHspgni","loaderSpinner":"DF4R7e5H","loader-spinner":"DF4R7e5H"};